import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';

@Component({
    selector: 'data-field-view-custom-calendar',
    templateUrl: './custom-calendar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewCustomCalendarComponent extends FiDataFieldViewBase {}
